/**
 * Route for `campaign-description-rich-text-editor`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CampaignDescriptionRichTextEditorPage } from "../features/campaign-description-rich-text-editor/CampaignDescriptionRichTextEditorPage";

export const campaignDescriptionRichTextEditorRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/campaign-description-rich-text-editor",
	component: CampaignDescriptionRichTextEditorPage,
});

export default campaignDescriptionRichTextEditorRoute;
